
export enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error'
}

export interface LogEntry {
  level: LogLevel
  message: string
  timestamp: Date
  context?: string
  data?: any
  userId?: string
  route?: string
}

class Logger {
  private static instance: Logger
  private logs: LogEntry[] = []
  private maxLogs = 1000

  private constructor() {}

  static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger()
    }
    return Logger.instance
  }

  private addLog(level: LogLevel, message: string, context?: string, data?: any) {
    const logEntry: LogEntry = {
      level,
      message,
      timestamp: new Date(),
      context,
      data,
      route: window.location.pathname,
      userId: this.getCurrentUserId()
    }

    this.logs.unshift(logEntry)
    
    // Manter apenas os últimos logs
    if (this.logs.length > this.maxLogs) {
      this.logs = this.logs.slice(0, this.maxLogs)
    }

    // Log no console do navegador
    this.logToConsole(logEntry)
  }

  private logToConsole(entry: LogEntry) {
    const prefix = `[${entry.timestamp.toISOString()}] ${entry.level.toUpperCase()}`
    const context = entry.context ? ` [${entry.context}]` : ''
    const message = `${prefix}${context}: ${entry.message}`

    switch (entry.level) {
      case LogLevel.DEBUG:
        console.debug(message, entry.data)
        break
      case LogLevel.INFO:
        console.info(message, entry.data)
        break
      case LogLevel.WARN:
        console.warn(message, entry.data)
        break
      case LogLevel.ERROR:
        console.error(message, entry.data)
        break
    }
  }

  private getCurrentUserId(): string | undefined {
    // Implementar lógica para obter ID do usuário atual
    return undefined
  }

  debug(message: string, context?: string, data?: any) {
    this.addLog(LogLevel.DEBUG, message, context, data)
  }

  info(message: string, context?: string, data?: any) {
    this.addLog(LogLevel.INFO, message, context, data)
  }

  warn(message: string, context?: string, data?: any) {
    this.addLog(LogLevel.WARN, message, context, data)
  }

  error(message: string, context?: string, data?: any) {
    this.addLog(LogLevel.ERROR, message, context, data)
  }

  getLogs(level?: LogLevel): LogEntry[] {
    if (level) {
      return this.logs.filter(log => log.level === level)
    }
    return [...this.logs]
  }

  clearLogs() {
    this.logs = []
  }
}

export const logger = Logger.getInstance()
